import { useEffect } from 'react';
import { type EventCreatorWithKey } from '@epihub/core/src/events';
import { navigationEventEmitter } from '@epihub/core/src/routes';
import { useLatestRef } from '../hooks/useLatestRef';

export function useEventListener<Event extends EventCreatorWithKey<any, any>>(
  event: Event,
  cb: (data: Event extends EventCreatorWithKey<infer Data, any> ? Data : never) => void,
) {
  const cbRef = useLatestRef(cb);
  useEffect(() => {
    const { unsubscribe } = navigationEventEmitter.listen(event, (data) => {
      return cbRef.current(data);
    });
    return () => unsubscribe();
  }, []);
}
